export default function () {
    return {
        current: 8,
        // drag: false,
        // dragOrigin: 0,
        init() {
            const elements = this.getAllElements();
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                element.addEventListener('click', () => {
                    this.setActive(i);
                })
            }
            
            window.addEventListener('resize', () => {
                this.setActive(this.current);
            });
            /* Setup buttons */
            const { previous, next } = this.$refs;
            const timelineLength = this.getAllElements().length
            previous.addEventListener('click', () => {
                const targetIndex = Math.max(0, this.current - 1);
                this.setActive(targetIndex);
            })
            next.addEventListener('click', () => {
                const targetIndex = Math.min(timelineLength - 1, this.current + 1);
                this.setActive(targetIndex);
            })

            // this.setActive(this.getElementByIndex(this.current));

            // this.$refs.container.addEventListener('mousedown', event => {
            //     this.drag = true;
            //     this.dragOrigin = event.clientX;
            //     const bound = this.$refs.container.getBoundingClientRect();
            //     console.log(bound)
            // })

            // window.addEventListener('mouseup', () => {
            //     this.drag = false;
            //     this.dragOrigin = 0;
            // })

            // window.addEventListener('mousemove', event => {
            //     if (this.drag) {
            //         console.log('bruh', event.clientX);
            //     }
            // })
            this.setActive(this.current);
        },
        setActive(index) {
            const el = this.getElementByIndex(index);
            this.current = index;
            const elements = this.getAllElements();
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                element.classList.remove('active');
            }
            
            // const { width: elementWidth, x: elementX } = el.getBoundingClientRect();
            const { width: documentWidth } = document.documentElement.getBoundingClientRect();
            
            // const elementCenterX = elementX + (elementWidth / 2);

            // const distance = (documentWidth / 2) - elementCenterX;
            // const containerX = this.$refs.container.getBoundingClientRect().x;

            // const targetX = (containerX - (elementWidth / 2)) + distance;
            // console.log({ elementWidth, elementX, elementCenterX, documentWidth, distance, targetX});
            
            // const { x: elx, width: elw } = el.getBoundingClientRect();
            // const { width: dw } = document.documentElement.getBoundingClientRect();
            // const { x: cx } = this.$refs.container.getBoundingClientRect();
            // const elcx = elx + (elw / 2);
            // const delta = cx + elcx;
            // const dist = (dw / 2) - delta;

            // console.log( {elx, elw, dw, elcx, delta, dist});
            const wrapper = this.$refs.wrapper;
            const parentX = this.$refs.container.getBoundingClientRect().x;
            const { x: elementX, width: elementWidth } = el.getBoundingClientRect();

            /* Find element x relative to parent */
            const relativeX = parentX - elementX;

            /* 
                The translateX value is equal to the containers origin x position 
                + the elements relative x position (minus half the elements width)
            */
            const originX = (documentWidth / 2) - wrapper.getBoundingClientRect().x;

            const dist = originX + (relativeX - el.getBoundingClientRect().width / 2);
        

            el.classList.add('active');
            this.$refs.container.style.transform = `translateX(${dist}px)`;
            // this.$refs.container.style.transform = `translateX(${targetX}px)`;
        },
        getAllElements() {
            return this.$el.querySelectorAll('.timeline__element');
        },
        getElementByIndex(index) {
            return this.getAllElements()[index];
        },
        isFirst() {
            return this.current === 0;
        },
        isLast() {
            return this.current === this.getAllElements().length - 1;
        }
    }
}